module.exports = __webpack_public_path__ + "img/face3.230d39b8.gif";